import { useLayoutEffect, useRef } from 'react'

const useLatest = (value: any) => {
    const valueRef = useRef(value)

    useLayoutEffect(() => {
        valueRef.current = value
    }, [value])

    return valueRef
}

export default useLatest
